import angular from 'angular';
import template from './participant-video-frame-mini.html';
import mobileActionsMini from './mobile-actions-mini/mobile-actions-mini';
import desktopActions from './desktop-actions/desktop-actions';
import * as call from '../../../../modules/call';
import * as localMedia from '../../../../modules/local-media';
import { isActiveSpeakerOfGroupCall } from '../../../../modules/call/helpers';
class ParticipantVideoFrameMiniController {
    constructor($element, $scope, participantVideoFrameService, $ngRedux) {
        this.$element = $element;
        this.$scope = $scope;
        this.participantVideoFrameService = participantVideoFrameService;
        this.$ngRedux = $ngRedux;
        this.callPublisherErrorVariant = () => {
            return this.isGalleryView
                ? call.constants.CallFrameVariant.Full
                : call.constants.CallFrameVariant.Mini;
        };
        this.unsubscribeFromStore = this.$ngRedux.connect(this.mapStateToThis)(this);
    }
    $onInit() {
        this.$scope.$watch('$ctrl.withVideo', () => {
            if (!this.withVideo)
                return;
            this.participantVideoFrameService.updateVideo(this.stream, this.$element[0]);
            if (!this.isGalleryView) {
                this.participantVideoFrameService.setPreferredResolutionToMini(this.stream);
            }
        });
    }
    $onChanges(changes) {
        if (!changes.isGalleryView)
            return;
        if (changes.isGalleryView.currentValue === true) {
            this.participantVideoFrameService.setPreferredResolutionForGalleryView(this.stream, this.peopleCount);
        }
        else if (changes.isGalleryView.previousValue === true &&
            changes.isGalleryView.currentValue === false) {
            this.participantVideoFrameService.setPreferredResolutionToMini(this.stream);
        }
    }
    get isHighlighted() {
        return isActiveSpeakerOfGroupCall(this.stream.stream);
    }
    mapStateToThis(state) {
        return {
            hasVideo: localMedia.selectors.hasVideo(state),
            hasAudio: localMedia.selectors.hasAudio(state),
        };
    }
    $onDestroy() {
        this.unsubscribeFromStore();
    }
}
const participantVideoFrameMiniComponent = {
    template,
    bindings: {
        placeholder: '<',
        disabled: '<',
        withVideo: '<',
        stream: '<',
        onToggleAudio: '&',
        onCallEnd: '&',
        username: '<',
        isInGroupCall: '<',
        isGalleryView: '<',
        peopleCount: '<',
        isVideoDisabled: '<',
        onSelect: '&',
        isPinned: '<',
        avatarPicture: '<',
        videoSubscriberId: '<',
        isPatient: '<',
        hasPublisherError: '<',
    },
    controller: ParticipantVideoFrameMiniController,
};
export default angular
    .module('doxy.videoChat.callFrames.participantVideoFrameMiniComponent', [
    mobileActionsMini,
    desktopActions,
])
    .component('participantVideoFrameMini', participantVideoFrameMiniComponent)
    .name;
